import { useQueryClient } from '@tanstack/react-query';

import { type CommunityDetail, type Image, createCommunityDetail } from 'models';

import { useMutation } from 'query';
import { updateCommunity } from '../../services';
import { getCommunityQueryKey } from '../keys';

export const useUpdateCommunityMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<
    CommunityDetail,
    { data: { description?: string; htmlDescription?: string; image?: Image }; id: string }
  >({
    async mutationFn({ data, id }) {
      const communityResponse = await updateCommunity(id, {
        cover_photo: data.image,
        description: data.description,
        html_description: data.htmlDescription,
      });

      return createCommunityDetail(communityResponse.data);
    },
    async onError(_, parameters) {
      await queryClient.invalidateQueries({ queryKey: getCommunityQueryKey({ id: parameters.id }) });
      // TODO this will be removed with useCommunityDataObjectQuery
      await queryClient.invalidateQueries({
        queryKey: ['data-object', ...getCommunityQueryKey({ id: parameters.id })],
      });
    },
    async onSuccess(data, parameters) {
      queryClient.setQueryData(getCommunityQueryKey({ id: parameters.id }), data);
      // TODO this will be removed with useCommunityDataObjectQuery
      await queryClient.invalidateQueries({
        queryKey: ['data-object', ...getCommunityQueryKey({ id: parameters.id })],
      });
    },
  });
};
